<template>
  <section class="ugc-new-top-bar row">
    <div class="ugc-new-top-bar-logo-title-wrapper">
      <div class="ugc-new-top-bar-logo">
        <img :src="`${assetsPath}/images/randomizer/custom_logo_red.png`" alt/>
      </div>
      <div>
        <h3 class="ugc-new-top-bar-title">{{ translations.ugcEPTopNavTitle }}</h3>
      </div>
      <div slot="top-right">
        <button type="button" class="ugc-new-top-bar-close" title="Close" @click="$emit('close')">
          <span class="icon-close"></span>
        </button>
      </div>
    </div>
    <div class="ugc-new-top-bar-steps-view-wrapper">
      <ugc-new-steps-view></ugc-new-steps-view>
    </div>
  </section>
</template>

<script>
import UgcNewStepsView from "./NewStepsView";

export default {
  name: "UgcNewTopbar",
  components: {
    UgcNewStepsView
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    assetsPath() {
      return this.$store.state.endPoints.customizer.customsAssets;
    }
  },
};
</script>
